import { h, ref } from 'vue';
import { Modal, Radio } from 'ant-design-vue';
import '@/assets/styles/renderRevisionChoice.css';

export const RENDER_REVISION_CHOICE_REQUIRED = 'render_revision_choice_required';
export const RenderScope = Object.freeze({ Requested: 'requested', Both: 'both' });

const RENDER_NAMES = { unreal: 'Unreal', gltf: 'GLTF' };

const renderOption = (value, title, description) => h(
  Radio,
  { value, class: 'render-revision-choice__option' },
  () => [
    h('span', { class: 'render-revision-choice__title' }, title),
    h('span', { class: 'render-revision-choice__description' }, description),
  ],
);

const renderOptions = (requested, retained, revision) => [
  renderOption(RenderScope.Requested, `Только ${requested}`, [
    `${requested} — по текущей планировке.`,
    h('br'),
    `${retained} — останется на `,
    revision ? 'ревизии ' : 'прежней ревизии.',
    revision ? h('span', { class: 'render-revision-choice__revision' }, `№${revision}`) : null,
  ]),
  renderOption(RenderScope.Both, 'Unreal и GLTF', 'Оба виджета — по текущей планировке.'),
];

export const isRenderRevisionChoiceError = (error) => error?.response?.status === 409
  && error?.response?.data?.code === RENDER_REVISION_CHOICE_REQUIRED;

export const chooseRenderRevision = (details) => new Promise((resolve) => {
  const scope = ref(RenderScope.Requested);
  const requested = RENDER_NAMES[details.requested_render_type];
  const retained = RENDER_NAMES[details.retained_render_type];
  const modal = Modal.confirm({
    title: 'Какие виджеты обновить?',
    icon: null,
    closable: true,
    width: 570,
    wrapClassName: 'render-revision-choice',
    content: () => h('div', [
      h('p', { class: 'render-revision-choice__intro' }, `После рендера ${retained} планировка изменилась.`),
      h(Radio.Group, {
        value: scope.value,
        class: 'render-revision-choice__options',
        'onUpdate:value': (value) => {
          scope.value = value;
          modal.update({ okText: value === RenderScope.Both ? 'Рендерить оба' : `Рендерить ${requested}` });
        },
      }, () => renderOptions(requested, retained, details.retained_revision_id)),
    ]),
    okText: `Рендерить ${requested}`,
    cancelText: 'Отмена',
    centered: true,
    onOk: () => resolve({ render_scope: scope.value, render_source_key: details.render_source_key }),
    onCancel: () => resolve(null),
  });
});
